/**
 * One search over a shipment row, shared by the consoles.
 *
 * It reads the *formatted* rows the tables render, so the keys here are the
 * ones the formatters produce — the raw record's `sbNumbers`, `destCode` and
 * `flightNumbers` are never present on them, which is why an S/B number used
 * to find nothing on air export.
 *
 * Air and sea name the same things differently, so both names are listed and
 * whichever exists on the row is the one that gets read.
 */
const FIELDS = [
  // the number on the job
  'awbNumber', 'awbNo', 'blNumber', 'blNo', 'containerNo',
  // shipping bill — air formats it as sbNumber, sea as sbNo
  'sbNumber', 'sbNo',
  // who it belongs to
  'customerName', 'username', 'customer', 'exporterName', 'consigneeName', 'buyerName',
  // the flight
  'flightNo', 'flightNumbers',
  // where it is going — air first, then sea
  'cityCode', 'destCode', 'destination', 'destCity', 'destCountry',
  'portCode', 'portOfLoading', 'portOfDischarge', 'portOfDischargeCode',
  'portOfFinalDestination', 'countryOfFinalDestination',
];

const textOf = (value) => {
  if (value === null || value === undefined || value === '' || value === '-') return '';
  return String(Array.isArray(value) ? value.join(' ') : value).toLowerCase();
};

// An S/B or an AWB is as often typed without its separators as with them.
const bare = (text) => text.replace(/[\s/\\-]/g, '');

/** `matchesShipmentSearch(row, term)` — true when nothing is being searched. */
export const matchesShipmentSearch = (row, term) => {
  const q = String(term || '').trim().toLowerCase();
  if (!q) return true;
  const qBare = bare(q);
  return FIELDS.some((key) => {
    const text = textOf(row?.[key]);
    if (!text) return false;
    return text.includes(q) || (qBare && bare(text).includes(qBare));
  });
};

export default matchesShipmentSearch;
